import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  acknowledge,
  orderEligibilitiesMockNotEligibleToRefundForSingleBound,
  orderForSingleBoundAcknowledged,
  orderForSingleBoundAcknowledgedChangeAllowed,
  orderForSingleBoundDisrupted,
} from '../../../mock/data';
import {
  flightDisruptionWarning,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries';

export const singleBoundDisruptedMock: MockMap = {
  retrieveOrder: [createMockData(orderForSingleBoundDisrupted, [], [flightDisruptionWarning]),
    createMockData(orderForSingleBoundAcknowledged)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleToRefundForSingleBound, [], [orderNotEligibleForRefundWarning])],
  acknowledge: [createMockData(acknowledge)]
};

export const singleBoundNonDisruptedMock: MockMap = {
  retrieveOrder: [createMockData(orderForSingleBoundAcknowledged)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleToRefundForSingleBound, [], [orderNotEligibleForRefundWarning])]
};

export const singleBoundNonDisruptedChangeAllowedMock: MockMap = {
  retrieveOrder: [createMockData(orderForSingleBoundAcknowledgedChangeAllowed)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleToRefundForSingleBound, [], [orderNotEligibleForRefundWarning])]
};
